<footer class="bottom-section-wrap">
  <h1>FALE COM A GENTE!</h1>
  <div class="btn-container-1">
    <app-falar-vendedor-button></app-falar-vendedor-button>
  </div>
  <p><b>Fale diretamente</b> com nosso Vendedor pelo WhatsApp!</p>
  <h2>NOSSOS PRODUTOS</h2>
  <app-lista-servicos></app-lista-servicos>
</footer>
<section class="contact">
  <h1><span>VISITE</span> NOSSA LOJA!</h1>
  <div class="info-items">
    <app-info-item class="info-item" icon="localization" label="PARNAMIRIM"
      link="https://www.google.com.br/maps/place/Sonora+Musical/@-5.9160068,-35.2748641,19z/data=!4m15!1m8!3m7!1s0x7b25710bca19c79:0x51a3d98e1373c677!2sR.+Dorothy+de+Moura+Lima,+290+-+Santos+Reis,+Parnamirim+-+RN,+59141-100!3b1!8m2!3d-5.9160081!4d-35.2742204!16s%2Fg%2F11cs9j48gk!3m5!1s0x7b25710bc8e2591:0x60550adcc82f1356!8m2!3d-5.916064!4d-35.2741853!16s%2Fg%2F11clgj6htg?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoASAFQAw%3D%3D"></app-info-item>
    <app-info-item class="info-item" icon="instagram" label="SIGA-NOS"
      link="https://www.facebook.com/sonoramusical"></app-info-item>
  </div>
  <div style="padding: 0 1rem; margin-top: 1rem;">
    <app-info-item icon="phone" class="info-item" label="(84) 98684.5330"
      link="https://wa.me/5584986845330?text=%C2%A9%20Sonora%20Musical%0A%3E%3E%0AOl%C3%A1!%20Obrigado%20pelo%20contato!%20Como%20posso%20ajudar%20voc%C3%AA%3F"></app-info-item>
  </div>
  <div class="bottom">
    <p>® Copyright 2025 Sonora Musical. Todos os direitos reservados.</p>
    <a target="_blank" href="https://silvanohebert.com.br/">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.455 13">
        <path
          d="M8.459,3.347H6.939v3.07l-4.2-2.572a.628.628,0,0,1-.249-.5V2.489H4.727V0H2.018A2.012,2.012,0,0,0,0,2.019V8.243L2.488,9.764v-3.1l4.23,2.572a.616.616,0,0,1,.249.47v.111a.685.685,0,0,1-.691.691H4.727V13H7.436a2.03,2.03,0,0,0,2.018-2.019V4.315A1,1,0,0,0,8.459,3.347Z"
          fill="#fff" />
      </svg>
    </a>
  </div>
</section>
